<footer class="footer">
    2019, <em>Dryclean Depot</em> All rights reserved.
</footer>